"use client"

import { useState, useEffect, useCallback } from "react"
import { Input } from "./input"

interface DebouncedInputProps extends Omit<React.ComponentProps<"input">, "onChange"> {
  value: string
  onChange: (value: string) => void
  debounceMs?: number
  placeholder?: string
}

export function DebouncedInput({
  value: initialValue,
  onChange,
  debounceMs = 300,
  placeholder,
  ...props
}: DebouncedInputProps) {
  const [value, setValue] = useState(initialValue)

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  const debouncedOnChange = useCallback(
    (newValue: string) => {
      onChange(newValue)
    },
    [onChange]
  )

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (value !== initialValue) {
        debouncedOnChange(value)
      }
    }, debounceMs)

    return () => clearTimeout(timeoutId)
  }, [value, debounceMs, debouncedOnChange, initialValue])

  return (
    <Input
      {...props}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder={placeholder}
    />
  )
} 